import {useState} from 'react'
import { MdKeyboardArrowDown } from "react-icons/md";
import { MdKeyboardArrowUp } from "react-icons/md";
import { CiSquarePlus } from "react-icons/ci";

const sportsList = [
  {
    name: "Politics",
    subCategory: [
      {
        name: "Assembly Election 2025",
        subCategory: ["Assembly Election 2025"],
      },
    ],
  },
  {
    name: "Cricket",
    subCategory: [
      {
        name: ["T10 XI",],
        subCategory: ["Adelaide Strikers XI Vs Sydney Sixer XI"],
      },
      {
        name: ["T5 XI",],
        subCategory: ["TKR XI Vs SLZ XI"],
      },
      {
        name: ["ICC Cricket World Cup League 2",],
        subCategory: ["Namibia v Canada"],
      },
      {
        name: ["Womens International Twenty20 Matches",],
        subCategory: ["New Zealand Women v Sri Lanka Women"],
      },
      {
        name: ["Virtual Cricket League",],
        subCategory: ["Australia T10 v New Zealand T10","Bangladesh T10 v Pakistan T10","Zew Zealand T10 v India T10", "Pakistan T10 v Sri Lanka T10","South Africa v Bangladesh T10", "Trinbago Riders T10 v Amazon Warriors T10"],
      },
      {
        name : ["International Twenty20 matchs"],
        subCategory : ["New Zealand v Pakistan"]
      },
      {
        name : ["Testing Game"],
        subCategory : ["Test A v Test B"]
      },
      {
        name : ["International T20 Masters League"],
        subCategory : ["India Masters v West Indies Masters"]
      },
      {
        name : ["Indian Premier League"],
        subCategory : ["Indian Premier League"]
      },
      {
        name : ["Womens Premier League"],
        subCategory : ["Delhi Capitals W v Mumbai Indians W "]
      },
      {
        name : ["Womens Premier League"],
        subCategory : ["Delhi Capitals W v Mumbai Indians W ", "Womens Premier League"]
      },
      {
        name : ["CSA Provincial One-Day Challenge Div 1"],
        subCategory : ["Boland v Dolphins"]
      },

    ],
  },
  {
    name: "Football",
    subCategory: [
      {
        name: "JAPAN J3 League",
        subCategory: ["Kamatamare Sanuki v FC RyuKyu", "KitaKyushu v Vanraure Hachinohe", "Sagamihara v Nara Club"],
      },
      {
        name: "AUSTRALIA New South Wales League 2",
        subCategory: ["Bankstown United - Gladesville Ryde Magic", "Dunbar Rovers - Central Cost United", "Nepean - Parramatta Eagles","Stanemore Hawks - GraneVille Rage"],
      },
      {
        name: "TURKEY 1. Lig",
        subCategory: ["Ankaragucu v 76 Igdir Belediyespor", "Manisa FK v Pendikspor", "Umraniyespor v Boluspor"],
      },
      {
        name: "AUSTRALIA NPL NSW",
        subCategory: ["APIA Leichhardt FC - St George FC", "Blacktown City FC - Sydney Olympic FC", "Mount Druit Town Rangers - Central Coast Mariners FC 1st Grade","NWS Spirit FC - Sydney United 58 FC","St George City FA - Manly United FC"],
      },
      {
        name: "ENGLAND Premier League",
        subCategory: ["Bournemouth v Brentford", "Everton v West Ham", "Ipswich v Nottm Forest","Man City v Brighton","Southampton v Wolves"],
      },
    ],
  },
]

const AllSports = () => {
    const [isOpen, setOpen] = useState(false);
    const [expandedIndex, setExpandedIndex] = useState(null); // Track which category is open
    const [subExpandedIndex, setSubExpandedIndex] = useState(null);

  return (
    <>
       <div className="bg-[#0088CC] text-white pt">
       <li
          className="flex items-center justify-between cursor-pointer"
          onClick={() => setOpen(!isOpen)}
        >
          <span className="font-semibold h-[30px] cursor-pointer">
            All Sports
          </span>
          {isOpen ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
        </li>
      </div>

      {isOpen && (
        <ul className="bg-[#bbbbbb] transition-all duration-75">
        {sportsList.map((category, index) => (
          <li key={index} className="border-b border-gray-500 pt-1"> {/* ❌ Removed h-[30px] */}
            <span
              className="flex items-center cursor-pointer gap-1"
              onClick={() => setExpandedIndex(expandedIndex === index ? null : index)}
            >
              <CiSquarePlus />
              {category.name}
              {expandedIndex === index ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
            </span>
      
            {expandedIndex === index && category.subCategory && (
              <ul className="bg-[#bbbbbb] ml-6 transition-all duration-200">
                {category.subCategory.map((sub, subIndex) => (
                  <li key={subIndex} className="ml-4 border-b border-gray-500 pt-1 w-[200px]"> {/* ❌ Removed h-[30px] */}
                    <span
                      className="cursor-pointer flex items-center gap-1"
                      onClick={() => setSubExpandedIndex(subExpandedIndex === subIndex ? null : subIndex)}
                    >
                      {sub.name} {subExpandedIndex === subIndex ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
                    </span>
      
                    {subExpandedIndex === subIndex && sub.subCategory && (
                      <ul className="bg-[#bbbbbb] ml-6">
                        {sub.subCategory.map((subItem, subItemIndex) => (
                          <li key={subItemIndex} className="ml-4 bg-red-500 mb-1 rounded px-2 py-1">{subItem}</li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
                   )}
    </>
  )
}

export default AllSports